import { useColorModeValue } from '@chakra-ui/react';
import { Panel } from '@gamma/ui/layout';
import { ErrorMessage, GraphQLReqStatus } from '@gamma/ui/progress';
import { graphqlErrorRedirects } from '../../../../shared/constants';
import { i18n } from '../../../../shared/localization';
import { IGetDetectionPeriodSummary } from '../../../detections/queries';

import { useUserSession } from '../../../../shared/hooks';
import { StatisticPanel } from '../StatisticPanel';

interface TotalDetectionsPanelProps {
  data?: IGetDetectionPeriodSummary;
  loading: boolean;
  error?: ErrorMessage;
}

export const TotalDetectionsPanel = ({
  data,
  loading,
  error,
}: TotalDetectionsPanelProps) => {
  const { signOut } = useUserSession();

  const iconBgColor = useColorModeValue('purple.200', 'purple.700');

  const { current, previous, pct_chg } =
    data?.getDetectionPeriodSummary?.total_alert_categories || {};

  const { heading } = i18n.pages.securityOverview.panels.totalDetections;

  if (loading || error) {
    return (
      <Panel>
        <GraphQLReqStatus
          loading={loading}
          error={error}
          signOut={signOut}
          extended={graphqlErrorRedirects}
        />
      </Panel>
    );
  }

  return (
    <StatisticPanel
      iconBgColor={iconBgColor}
      heading={heading}
      current={current}
      previous={previous}
      pct_chg={pct_chg}
      infoLabelTestId="alert-categories-with-detections-info-label"
    />
  );
};
